import React, {useEffect, useState} from 'react'

export const NotificationContext = React.createContext(null);

const Notifications = (props) => {
  const [notification, setNotification] = useState({});

  useEffect(() => {
    if (!notification.content) {
      return;
    }

    if (notification.hideDelay > 0) {
      const timeout = setTimeout(() => {
        setNotification({progress: 0})
      }, notification.hideDelay);
      return () => clearTimeout(timeout);
    }
  }, [notification]);

  return (
    <NotificationContext.Provider value={[notification, setNotification]}>
      {props.children}
      <div className="notifications">
        <div className={"notification is-" + (notification.color || "info") + " " + (notification.visible ? "is-visible" : "")}>
          <div className={"notification-title" + (notification.title ? "" : " is-hidden")}>{notification.title}</div>
          <div className="notification-body">
            <span className={"notification-icon" + (notification.icon ? " fz fz-" + notification.icon : "")}/>
            <div className="notification-content">{notification.content}</div>
          </div>
          <progress className={"progress is-" + (notification.color || "info") + (notification.progress >= 0 ? "" : " is-hidden")}
                    value={notification.progress} max="100"/>
        </div>
      </div>
    </NotificationContext.Provider>
  );
}
export default Notifications
